var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},[_c('banner',{attrs:{"img":"../assets/img/appDown.jpg","title":"下载APP"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }